import NgqlUI from 'gql/ninegqlUI'

import type { NineGQLUIAdapter } from './uiAdapter'
import type { GQLApolloClient } from './types'

/**
 * 현재 활성 UI 어댑터. 기본값은 Ant Design 구현(`NgqlUI`).
 * `setUIAdapter()` 로 shadcn/ui 등 다른 UI 프레임워크 구현으로 교체할 수 있다.
 *
 * ES module 의 `let` export 는 import 시점 스냅샷으로 고정되므로, 외부 파일은
 * 이 변수에 직접 접근하지 말고 `getUIAdapter()` 를 통해 최신 참조를 얻어야 한다.
 */
let _uiAdapter: NineGQLUIAdapter = NgqlUI as NineGQLUIAdapter

export function getUIAdapter(): NineGQLUIAdapter {
  return _uiAdapter
}

export const ngqlInfo: {
  defaultClient: GQLApolloClient | null
} = {
  defaultClient: null,
}

export function setDefaultClient(client: GQLApolloClient): void {
  ngqlInfo.defaultClient = client
}

/**
 * 렌더링에 사용할 UI 프레임워크 어댑터를 교체한다.
 *
 * 순환 의존을 피하기 위해 `generateDetailUIByKey` 함수 참조 주입은 `index.ts` 의 wrapper 가
 * 수행한다. 이 함수는 어댑터 포인터 교체만 담당.
 */
export function setUIAdapter(adapter: NineGQLUIAdapter): void {
  _uiAdapter = adapter
}
